<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">
         <span>短信任务 / 发送详情</span>
         <el-button class="back" type="primary" @click="$router.go(-1)">返回</el-button>
      </div>

      <div class="search-wrapper">
         <el-form :inline="true" v-model="formParam">
            <el-form-item label="手机号">
               <el-input placeholder="请输入手机号" v-model="formParam.phone">
               </el-input>
            </el-form-item>
            <el-form-item label="短信发送状态">
               <el-select placeholder="请选择状态" v-model="formParam.status">
                  <el-option label="全部" :value="-1"></el-option>
                  <el-option label="发送中" :value="0"></el-option>
                  <el-option label="成功" :value="1"></el-option>
                  <el-option label="失败" :value="2"></el-option>
               </el-select>
            </el-form-item>
         </el-form>
         <el-button type="primary" @click="queryList">搜索</el-button>
         <el-button @click="clickReset">重置</el-button>
      </div>

      <div class="action-wrapper">
         <div class="info-wrapper">
            <span>全部账号：{{ infoRow.sendCount }}</span>
            <span>失败数量：{{ infoRow.failCount }}</span>
            <span>成功数量：{{ infoRow.successCount }}</span>
         </div>
         <el-button type="primary" @click="clickExport">导出</el-button>
      </div>

      <div class="content-wrapper">
         <el-table :data="tableData">
            <el-table-column align="center" label="手机号" prop="phone"></el-table-column>
            <el-table-column align="center" label="省份" prop="province">
               <template scope="{ row }">{{ handleProvince(row) }}</template>
            </el-table-column>
            <el-table-column align="center" label="性别" prop="gender"></el-table-column>
            <el-table-column align="center" label="入学年份" prop="caid"></el-table-column>
            <el-table-column align="center" label="短信发送状态" prop="status"></el-table-column>
            <el-table-column align="center" label="内容" prop="content">
               <template scope="{ row }">
                  <el-popover placement="top" width="200" trigger="hover">
                     <div style="word-break: break-all;">{{ row.content.replace(/【运动世界校园】/, '') }}</div>
                     <span slot="reference">{{ handleContent(row.content) }}</span>
                  </el-popover>
               </template>
            </el-table-column>
            <el-table-column align="center" label="失败原因" prop="failReason">
               <template scope="{ row }">
                  <div v-if="row.status !== '成功'">{{ row.failReason }}</div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="返回时间" prop="updateTime">
               <template scope="{ row }">
                  {{ row.updateTime ? $util.dateFormat(new Date(row.updateTime), 'yyyy-MM-dd hh:mm:ss') : '' }}
               </template>
            </el-table-column>
         </el-table>

         <div class="pagination-wrapper">
            <el-pagination v-show="totalCount > 0" layout="prev, pager, next, jumper" :current-page="formParam.pageNum"
               :page-size='formParam.pageSize' :total="totalCount" @current-change="changeCurrentPage">
            </el-pagination>
         </div>
      </div>
   </div>
</template>

<script>
import { provinceListConst } from "../../../../common/constant.js";

export default {
   data() {
      return {
         loading: false,
         taskId: "",
         infoRow: {},
         formParam: {
            phone: "",
            status: -1,
            pageNum: 1,
            pageSize: 10
         },
         statusOptions: ["全部", "开启", "关闭"],
         tableData: [],
         totalCount: 0
      }
   },

   mounted() {
      this.taskId = this.$route.query.id;
      const row = this.$util.getStore("smsTaskRow");
      if (row && row != '{}') {
         this.$util.removeStore("smsTaskRow");
         this.infoRow = JSON.parse(row);
      }
      this.queryList();
   },

   methods: {
      // 查询列表
      queryList() {
         this.loading = true;
         this.$http({
            url: this.$util.domain + '/adminapi/v61200/sms/task/detail/page',
            method: 'POST',
            body: JSON.stringify({
               taskId: this.taskId,
               ...this.formParam,
               status: this.formParam.status === -1 ? undefined : this.formParam.status
            })
         }).then(response => {
            if (response.data.error === 10000) {
               let data = response.data.data;
               if (data.count) {
                  this.tableData = data.data;
                  this.totalCount = data.count;
               } else {
                  this.tableData = [];
                  this.totalCount = 0;
               }
            }
         }).catch(() => {
            this.$util.errorMsg('获取列表失败');

         }).finally(() => {
            this.loading = false;
         })
      },

      queryExport() {
         this.loading = true;
         this.$http({
            url: this.$util.domain + "/adminapi/v61200/sms/task/detail/export",
            method: "GET",
            params: { id: this.taskId },
            responseType: 'blob',
         }).then((res) => {
            if (res.data) {
               const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
               const downloadUrl = window.URL.createObjectURL(blob)
               const link = document.createElement('a')
               link.href = downloadUrl
               link.download = "短信任务_" + new Date().format("yyyyMMdd_hhmmss") + ".xlsx"; // 下载后的文件名
               document.body.appendChild(link)
               link.click()
               document.body.removeChild(link)
               window.URL.revokeObjectURL(downloadUrl)
               this.$util.successMsg('导出成功');
            } else {
               this.$util.errorMsg('导出失败');
            }
         }).catch((error) => {
            this.$util.errorMsg('导出失败');
         }).finally(() => {
            this.loading = false;
         });
      },

      // 点击重置
      clickReset() {
         this.formParam = {
            phone: "",
            status: -1,
            pageNum: 1,
            pageSize: 10
         }
         this.queryList();
      },

      // 点击导出
      clickExport() {
         this.queryExport();
      },

      // 切换页码
      changeCurrentPage(val) {
         this.formParam.pageNum = val;
         this.queryList();
      },

      // 处理省份
      handleProvince(row) {
         if (row.province) {
            return row.province.split(',').map(code => {
               const province = provinceListConst.find(item => item.value === code);
               return province ? province.label : '';
            }).join('、');
         } else {
            return "全部";
         }
      },

      // 处理内容展示
      handleContent(content) {
         const text = content.replace(/【运动世界校园】/, '');
         return text.length > 10 ? text.substring(0, 10) + '...' : text;
      },
   }
}
</script>

<style scoped>
.info-wrapper {
   margin-right: auto;
   display: flex;
   flex-direction: row;
   gap: 30px;
}
</style>


// WEBPACK FOOTER //
// SMSTaskDetail.vue?50cc4890